import {Injectable} from '@angular/core';
import {StringService} from './string.service';

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

@Injectable()
export class DateService {

  public static compare(a: string | Date, b: string | Date): number {
    return (new Date(a).getTime() - new Date(b).getTime());
  }

  public static compareDateWithoutTime(a: string | Date, b: string | Date): number {
    return DateService.compare(
      DateService.getIsoDate(a),
      DateService.getIsoDate(b),
    );
  }


  public static getFormattedDate(date: string | Date, format: string = 'dd/MM/yyyy'): string {
    if (typeof date === 'string') {
      date = new Date(date);
    }

    // pour prendre en charge d'autres formats, surement plus intelligent de faire appel à une lib externe (ou DatePipe d'angular ?)
    switch (format) {
      case 'dd/MM/yyyy':
        return StringService.strPad(date.getDate().toString(), 2, '0') + '/' +
          StringService.strPad((date.getMonth() + 1).toString(), 2, '0') + '/' +
          date.getFullYear();

      case 'yyyy-MM-dd':
        return date.getFullYear() + '-' +
          StringService.strPad((date.getMonth() + 1).toString(), 2, '0') + '-' +
          StringService.strPad(date.getDate().toString(), 2, '0');
      default:
        throw new Error('format de date non supporté par ce service');
    }
  }

    public static getFormatedTime(date: string | Date): string {
        if (typeof date === 'string') {
            date = new Date(date);
        }

        return StringService.strPad(date.getHours().toString(), 2, '0') + 'h' +
            StringService.strPad(date.getMinutes().toString(), 2, '0');
    }

  public static getIsoDate(date: string | Date | null = null): string {
    return DateService.getFormattedDate(date ?? (new Date()), 'yyyy-MM-dd');
  }

  public static getProgress(startDate: string | Date, endDate: string | Date, progressDate?: string | Date): number {
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    progressDate = progressDate ? new Date(progressDate) : new Date();

    if (progressDate <= startDate) {
      return 0;
    }

    if (progressDate >= endDate) {
      return 100;
    }

    return Math.round(100 * (progressDate.getTime() - startDate.getTime()) / (endDate.getTime() - startDate.getTime()));
  }

  public static addMonths(date: string | Date, months: number): Date {
    date = new Date(date);

    const d = date.getDate();

    date.setMonth(date.getMonth() + months, 1);
    const m = date.getMonth();

    date.setDate(d);
    if (date.getMonth() !== m) {
      date.setDate(0);
    }

    return date;
  }

  public static addDays(date: string | Date, days: number) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  public static getDaysInRange(dateA: string | Date, dateB: string | Date) {
    return DateService.getDiffInDays(dateA, dateB) + 1;
  }

  public static getDiffInDays(dateA: string | Date, dateB: string | Date) {
    const a = new Date(dateA);
    const b = new Date(dateB);

    // Discard the time and time-zone information.
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }

  public static sortByDate(a: string, b: string, direction: 'ASC' | 'DESC' = 'ASC') {
    const dateA = (new Date(a)).getTime();
    const dateB = (new Date(b)).getTime();
    return direction === 'ASC' ? dateA - dateB : dateB - dateA;
  }

  public getDateForInput(date: string | Date): string {
    return DateService.getIsoDate(date);
  }

}
